import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { ISetAgreementResult } from "./types";

interface IAgreement {
  oldAgreement: string;
  newAgreement: string;
}

export async function setAgreement({
  oldAgreement,
  newAgreement,
}: IAgreement): Promise<ISetAgreementResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/preferences`,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: [
        {
          op: "test",
          path: "/attributes/contactChannels",
          value: oldAgreement,
        },
        {
          op: "replace",
          path: "/attributes/contactChannels",
          value: newAgreement,
        },
      ],
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
